export default __webpack_public_path__ + "static/media/check.dd8178a9.svg";